import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { IApplicationState } from '../../stateManagement/states/ApplicationState';
import * as fromRoot from '../../stateManagement/rootReducer';
import { IPortalInfo } from '../../shared/types';
import * as _ from 'lodash';
import {LOCALE_ID} from '@angular/core';

export class CustomNgbDateParserFormatter extends NgbDateParserFormatter {
    datePipe = new DatePipe('en-US');
	dateFormatString = 'dd/MM/yyyy';
    //dateFormatString = 'yyyy-MM-dd';

	constructor(store: Store<IApplicationState>) {
		super();
		store.select(fromRoot.getApplicationPortalInformation).take(1).subscribe(
			(portalInfo: IPortalInfo) => this.dateFormatString = _.has(portalInfo, 'dateformat') ? portalInfo.dateformat : 'dd/MM/yyyy'
     
		);
	  }
	// constructor(
	// 	private dateFormatString: string) {
	// 	super();
    // }
    
    setDateFormat(format: string) {
        this.dateFormatString = format;
    }

	format(date: NgbDateStruct): string {
		if (date === null) {
			return '';
		}
		try {
		
           	return this.datePipe.transform(new Date(date.year, date.month - 1, date.day), 'dd/MM/yyyy');
          //  return this.datePipe.transform(new Date(date.year, date.month - 1, date.day), 'yyyy-MM-dd');
		} catch (e) {
			return '';
		}
	}
	formatForServer(date: NgbDateStruct): string {
		if (date === null) {
			return '';
		}
		try {
            //return this.datePipe.transform(new Date(date.year, date.month - 1, date.day), 'dd/MM/yyyy');
			return this.datePipe.transform(new Date(date.year, date.month - 1, date.day), 'yyyy-MM-dd');
		} catch (e) {
			return '';
		}
	}
	parse(value: string): NgbDateStruct {
		let returnVal: NgbDateStruct;
		if (!value) {
			returnVal = null;
		} else {
			try {
				//this is just a hack to fix the date -- need to a better solution fo future
                let dateReg = /^\d{4}([./-])\d{2}\1\d{2}$/

				if(value.match(dateReg)){
				//	console.log('matched');
				}else{
					let newvalue = value.split('/');
				//	console.log('new:'+newvalue);
					 value = newvalue[2]+'-'+newvalue[1]+'-'+newvalue[0];
				}
				//if
                let dateParts = this.datePipe.transform(value, 'dd/MM/yyyy').split('/');
				//console.log('date:'+dateParts);
				returnVal = {   year: parseInt(dateParts[2]), month: parseInt(dateParts[1]), day: parseInt(dateParts[0])  };
			} catch (e) {
				returnVal = null;
			}
		}
		return returnVal;
	}
}


// WEBPACK FOOTER //
// ./src/app/stage/services/customDateParserFormatter.service.ts